/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Select ssRNA and the calculator uses ribonucleotide masses, treating T as U so you can paste either alphabet.`)
};

const es_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Selecciona ARNss y la calculadora usa masas de ribonucleótidos, tratando T como U, así que puedes pegar cualquiera de los dos alfabetos.`)
};

const de_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wählen Sie ssRNA, und der Rechner verwendet Ribonukleotidmassen, wobei T als U behandelt wird, sodass Sie beide Alphabete einfügen können.`)
};

const nl_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Selecteer ssRNA en de calculator gebruikt ribonucleotidemassa's, waarbij T wordt behandeld als U zodat je beide alfabetten kunt plakken.`)
};

const fr_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Sélectionnez ARNsb et le calculateur utilise les masses ribonucléotidiques, traitant T comme U afin que vous puissiez coller l'un ou l'autre alphabet.`)
};

const it_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Seleziona ssRNA e il calcolatore usa le masse ribonucleotidiche, trattando T come U così puoi incollare entrambi gli alfabeti.`)
};

const pt_br2_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Selecione ssRNA e a calculadora usa massas de ribonucleotídeos, tratando T como U, para que você possa colar qualquer um dos dois alfabetos.`)
};

const pt_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Selecione ssARN e a calculadora usa as massas de ribonucleótidos, tratando T como U, pelo que pode colar qualquer um dos dois alfabetos.`)
};

const ja_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。ssRNAを選択すると、計算ツールはリボヌクレオチドの質量を使用し、TをUとして扱うため、どちらのアルファベットでも貼り付けることができます。`)
};

const zh_dnamw_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。选择 ssRNA 后，计算器会使用核糖核苷酸质量，并将 T 视为 U，因此你可以粘贴任一字母表的序列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_a4", locale)
	if (locale === "en") return en_dnamw_faq_a4(inputs)
	if (locale === "es") return es_dnamw_faq_a4(inputs)
	if (locale === "de") return de_dnamw_faq_a4(inputs)
	if (locale === "nl") return nl_dnamw_faq_a4(inputs)
	if (locale === "fr") return fr_dnamw_faq_a4(inputs)
	if (locale === "it") return it_dnamw_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_a4(inputs)
	if (locale === "pt") return pt_dnamw_faq_a4(inputs)
	if (locale === "ja") return ja_dnamw_faq_a4(inputs)
	return zh_dnamw_faq_a4(inputs)
};